const IMPACT_CAROUSEL_SELECTOR = '.impact-image-carousel .splide';
const ACTIVE_SLIDE_SELECTOR = '.splide__slide.is-active .impact-image-carousel-slide';
const VISIBLE_SLIDE_SELECTOR = '.splide__slide.is-visible .impact-image-carousel-slide';
const FALLBACK_SLIDE_SELECTOR = '.splide__slide .impact-image-carousel-slide';

const getActiveSlide = function ( carousel ) {
	return (
		carousel.querySelector( ACTIVE_SLIDE_SELECTOR ) ||
		carousel.querySelector( VISIBLE_SLIDE_SELECTOR ) ||
		carousel.querySelector( FALLBACK_SLIDE_SELECTOR )
	);
};

const syncCarouselHeight = function ( carousel ) {
	const track = carousel.querySelector( '.splide__track' );
	const list = carousel.querySelector( '.splide__list' );
	const activeSlide = getActiveSlide( carousel );

	if ( ! track || ! list || ! activeSlide ) {
		return;
	}

	const height = Math.ceil( activeSlide.getBoundingClientRect().height );

	if ( height <= 0 ) {
		return;
	}

	const nextHeight = height + 'px';

	if ( track.style.height !== nextHeight ) {
		track.style.height = nextHeight;
	}

	if ( list.style.height !== nextHeight ) {
		list.style.height = nextHeight;
	}
};

const createHeightScheduler = function ( carousel ) {
	let frameId = 0;

	return function () {
		if ( frameId ) {
			window.cancelAnimationFrame( frameId );
		}

		frameId = window.requestAnimationFrame( function () {
			frameId = 0;
			syncCarouselHeight( carousel );
		} );
	};
};

const watchCarouselHeight = function ( carousel ) {
	const list = carousel.querySelector( '.splide__list' );
	const scheduleHeightSync = createHeightScheduler( carousel );

	scheduleHeightSync();
	window.addEventListener( 'resize', scheduleHeightSync );
	window.addEventListener( 'load', scheduleHeightSync, { once: true } );

	if ( document.fonts && document.fonts.ready ) {
		document.fonts.ready.then( scheduleHeightSync ).catch( function () {} );
	}

	carousel.querySelectorAll( 'img' ).forEach( function ( image ) {
		if ( image.complete ) {
			return;
		}

		image.addEventListener( 'load', scheduleHeightSync, { once: true } );
	} );

	if ( list ) {
		const mutationObserver = new MutationObserver( scheduleHeightSync );
		mutationObserver.observe( list, {
			attributes: true,
			attributeFilter: [ 'class', 'style' ],
			childList: true,
			subtree: true,
		} );
	}

	if ( 'ResizeObserver' in window ) {
		const resizeObserver = new window.ResizeObserver( scheduleHeightSync );

		resizeObserver.observe( carousel );
		carousel.querySelectorAll( '.impact-image-carousel-slide, img, iframe' ).forEach( function ( element ) {
			resizeObserver.observe( element );
		} );
	}
};

/**
 * Keep impact carousel height aligned to the active slide.
 *
 * The shared carousel block reserves space for the tallest slide, which creates
 * large blank areas when a shorter caption is active.
 *
 * @returns {void}
 */
export function initImpactImageCarousel() {
	const carousels = document.querySelectorAll( IMPACT_CAROUSEL_SELECTOR );

	if ( carousels.length === 0 ) {
		return;
	}

	carousels.forEach( watchCarouselHeight );
}
